import React from 'react';
import SelectEngine from '../../engine/SelectEngine';
import { DatePicker as _DatePicker } from '@material-ui/pickers';
import moment from '../../../utils/momentWithLocale';
import parseDate from '../../../utils/parseDate';
import InputBase from '../../form/InputBase';
import styled from 'styled-components/macro';
import DueDateFilterEngine from '../engine/DueDateFilterEngine';

const DatePicker = styled(_DatePicker)`
  && {
    max-width: 266px;
    vertical-align: middle;
  }
  [class*='MuiInputBase-root'] {
    height: 35px;
  }
`;

const PrioritySelect = styled(SelectEngine)`
  && {
    margin: 0 1rem;
  }
`;

const EndUserTaskFiltersView = props => {
  return (
    <>
      <SelectEngine
        allowMultiSelect
        placeholder="Status"
        openMenuOptionParser={props.openMenuOptionParserForStatus}
        options={props.statusOptions}
        onChange={props.onStatusChange}
        value={props.statusValue}
      />
      <PrioritySelect
        allowMultiSelect
        placeholder="Priority"
        openMenuOptionParser={props.openMenuOptionParserForPriority}
        options={props.priorityOptions}
        onChange={props.onPriorityChange}
        value={props.priorityValue}
      />
      <DueDateFilterEngine
        counts={props.counts}
        value={props.dateFilters}
        onChange={props.onDateFiltersChange}
      />
    </>
  );
};

export default EndUserTaskFiltersView;
